import ApiHandler from '@/api/base'
import { CHECKINS_FEED_LIMIT, CHECKINS_PREVIEW_LIMIT } from '@/utils/check-ins/check-ins'

class CheckinApiHandler extends ApiHandler {
  async createCheckin({
    elementId,
    checkinDate = null,
    newValue,
    newStatus,
    comment = '',
    updateStatusForNestedElements = null,
    viewConfig = null
  } = {}) {
    const { data } = await this.http.post('/checkin', {
      elementId,
      checkinDate,
      newValue,
      newStatus,
      comment,
      updateStatusForNestedElements,
      viewConfig
    })

    return data
  }

  async updateCheckin({
    id,
    checkinDate = null,
    newValue,
    newStatus,
    comment = '',
    viewConfig = null
  } = {}) {
    const { data } = await this.http.put('/checkin', {
      checkinId: id,
      checkinDate,
      newValue,
      newStatus,
      comment,
      viewConfig
    })

    return data
  }

  async getElementCheckins({ elementId, limit = CHECKINS_PREVIEW_LIMIT, offset = 0 } = {}) {
    const { data } = await this.http.post('/checkin/search', {
      elementIds: [elementId],
      limit,
      startAt: offset
    })

    return data.checkins || []
  }

  //async deleteCheckin({ id }) {
  //  logAttentionPhrase('remove DeleteCheckin mock')
  //
  //  console.table({ id })
  //
  //  return new Promise((resolve, reject) => {
  //    setTimeout(() => {
  //       const coinToss = random(0, 10) > 80 // 20% chance to fail
  //
  //       if (coinToss) {
  //         reject(new Error('Sorry ne segodnya'))
  //       }
  //
  //      resolve()
  //    }, 1000)
  //  })
  //}

  async getAllowedDatesForFeedNavigation({ assigneeIds = null, groupIds = null } = {}) {
    const { data } = await this.http.post('/checkin/navigation', {
      // elementIds: [1148722],
      checkinOwnerIds: assigneeIds,
      groupIds
    })

    return data.dates || []
  }

  async getCheckinsForFeed({
    limit = CHECKINS_FEED_LIMIT,
    offset = 0,
    createDateTo = null,
    assigneeIds = null,
    groupIds = null
  } = {}) {
    const { data } = await this.http.post('/checkin/search', {
      // elementIds: [1148722],
      includeElementData: true,
      limit,
      startAt: offset,
      createDateTo,
      groupIds,
      checkinOwnerIds: assigneeIds
    })

    return data.checkins || []
  }
}

export default CheckinApiHandler
